import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

// Search icon from Hightouch UI
export function SearchIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10 6a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-6 4a6 6 0 1 1 10.89 3.476l4.817 4.817a1 1 0 0 1-1.414 1.414l-4.816-4.816A6 6 0 0 1 4 10Z"
        clipRule="evenodd"
      />
    </Icon>
  );
}
